// ---- helpers ----
export const fmtNum = (n, opts = {}) => {
  if (n === null || n === undefined || isNaN(Number(n))) return "—";
  return new Intl.NumberFormat(undefined, { maximumFractionDigits: 3, ...opts }).format(Number(n));
  // eslint-disable-next-line
};

export const fmtInt = (n) => (isFinite(n) ? new Intl.NumberFormat().format(Math.round(n)) : "—");

export const fmtDate = (s) => {
  if (!s) return "—";
  const d = new Date(s);
  if (isNaN(d.getTime())) return "—";
  return d.toLocaleDateString(undefined, { year: "numeric", month: "short", day: "2-digit" });
};

export const humanInterval = (secStr) => {
  const sec = Number(secStr);
  if (!isFinite(sec) || sec <= 0) return "—";
  const days = Math.floor(sec / 86400);
  const hours = Math.floor((sec % 86400) / 3600);
  const mins = Math.floor((sec % 3600) / 60);
  if (days > 0) return `${days}d ${hours}h`;
  if (hours > 0) return `${hours}h ${mins}m`;
  return `${mins}m`;
};


/**
 * Truncate a string to maxLen (including ellipsis), safely handling emoji.
 * Options:
 *  - position: 'end' | 'start' | 'middle'  (default: 'end')
 *  - ellipsis: string, e.g. '…' or '...'   (default: '…')
 *  - keepWholeWords: boolean               (default: false; only for position='end')
 */
export const truncate = (str, maxLen, opts = {}) => {
  const {
    position = 'end',
    ellipsis = '…',
    keepWholeWords = false
  } = opts;

  if (typeof str !== 'string') str = String(str ?? '');
  if (!Number.isFinite(maxLen) || maxLen <= 0) return '';
  if (str.length === 0) return '';

  const seg = (typeof Intl !== 'undefined' && Intl.Segmenter)
    ? new Intl.Segmenter(undefined, { granularity: 'grapheme' })
    : null;

  const toGraphemes = (s) =>
    seg ? [...seg.segment(s)].map(x => x.segment) : Array.from(s);

  const g = toGraphemes(str);
  const e = toGraphemes(ellipsis);

  if (g.length <= maxLen) return str;
  if (maxLen <= e.length) return e.slice(0, maxLen).join('');

  const cap = maxLen - e.length;

  if (position === 'start') {
    // Keep the last `cap` characters
    return e.join('') + g.slice(g.length - cap).join('');
  }

  if (position === 'middle') {
    const left = Math.ceil(cap / 2);
    const right = Math.floor(cap / 2);
    return g.slice(0, left).join('') + e.join('') + g.slice(g.length - right).join('');
  }

  // position === 'end'
  let head = g.slice(0, cap).join('');

  if (keepWholeWords) {
    const i = head.lastIndexOf(' ');
    if (i > 0) head = head.slice(0, i);
  }

  return head + e.join('');
}

